import {createApp} from "vue"
import i18n from "@/i18n"
import AppLogin from "@/views/AppLogin.vue"

import {initializeApp} from "@/app-initializer"

const app = createApp(AppLogin).use(i18n)

initializeApp(app)

app.mount("#app")
